<template>
  <div role="tablist">

    <div class="mb-4">
      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq1 = !faq1" block v-b-toggle.accordion1> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq1 = !faq1">
          <img v-if="faq1" block v-b-toggle.accordion1 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq1" block v-b-toggle.accordion1 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion1" accordion="my-accordion" role="tabpanel">
        <div class="row">
          <div class="col-md-6">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque.
            Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut
            faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu
            risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit.
            Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.
            <p>Curabitur id mattis nunc. Donec vitae odio sed ex pharetra maximus ultrices in diam. Ut accumsan nisl in
              lectus euismod placerat. Maecenas pulvinar laoreet risus, non volutpat nisl faucibus in. Donec purus
              velit, hendrerit et tortor vitae, blandit lacinia ipsum. Vivamus congue molestie ipsum, vitae consequat
              diam vehicula congue. Maecenas lacinia ligula vitae dolor convallis hendrerit. Aliquam erat volutpat.
              Vivamus a sodales libero, vel aliquet ipsum. Curabitur euismod, eros at dapibus ultrices, nibh ipsum
              pellentesque augue, vel laoreet nibh odio sed diam. Curabitur quis finibus urna.</p>
          </div>
          <div class="col-md-6">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque.
              Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut
              faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum
              eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit.
              Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.</p>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="mb-4">
      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq2 = !faq2" block v-b-toggle.accordion2> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq2 = !faq2">
          <img v-if="faq2" block v-b-toggle.accordion2 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq2" block v-b-toggle.accordion2 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>

    <div class="mb-4">

      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq3 = !faq3" block v-b-toggle.accordion4> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq3 = !faq3">
          <img v-if="faq3" block v-b-toggle.accordion4 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq3" block v-b-toggle.accordion4 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>

    <div class="mb-4">

      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq4 = !faq4" block v-b-toggle.accordion5> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq4 = !faq4">
          <img v-if="faq4" block v-b-toggle.accordion5 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq4" block v-b-toggle.accordion5 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion5" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>

    <div class="mb-4">

      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq5 = !faq5" block v-b-toggle.accordion6> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq5 = !faq5">
          <img v-if="faq5" block v-b-toggle.accordion6 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq5" block v-b-toggle.accordion6 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion6" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>

    <div class="mb-4">

      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq6 = !faq6" block v-b-toggle.accordion7> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq6 = !faq6">
          <img v-if="faq6" block v-b-toggle.accordion7 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq6" block v-b-toggle.accordion7 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion7" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>

    <div class="mb-4">

      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq7 = !faq7" block v-b-toggle.accordion8> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq7 = !faq7">
          <img v-if="faq7" block v-b-toggle.accordion8 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq7" block v-b-toggle.accordion8 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion8" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>

    <div class="mb-4">

      <div class="d-flex justify-content-between">
        <a class="btn-faq title2" @click="faq8 = !faq8" block v-b-toggle.accordion9> <b>¿Qué encontrarás en el Informe?</b></a>
        <a class="pointer" @click="faq8 = !faq8">
          <img v-if="faq8" block v-b-toggle.accordion9 :src='"../assets/img/close.png"' class="img-fluid">
          <img v-if="!faq8" block v-b-toggle.accordion9 :src='"../assets/img/open.png"' class="img-fluid">
        </a>
      </div>
      <hr>
      <b-collapse id="accordion9" accordion="my-accordion" role="tabpanel">
        <p class="card-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Mollitia, enim cupiditate! Alias, accusantium
          commodi? Corporis, eveniet? Recusandae magnam necessitatibus odit impedit! Iste, neque vitae earum vero
          corporis cupiditate magni dolores.
        </p>
      </b-collapse>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'faq',
    data() {
      return {
        faq1: true,
        faq2: true,
        faq3: true,
        faq4: true,
        faq5: true,
        faq6: true,
        faq7: true,
        faq8: true,

        faqs: [{
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
          {
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
          {
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
          {
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
          {
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
          {
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
          {
            faq: '¿Qué encontrarás en el Informe?',
            answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ut sollicitudin felis, at interdum neque. Quisque eleifend tellus quis eros imperdiet, in imperdiet turpis auctor. Donec in tellus tortor. Ut faucibus nisl quam, at sodales nisl fringilla sit amet. Ut quis mi quis metus aliquam vestibulum dictum eu risus. Donec luctus metus ligula, in rhoncus metus posuere sed. Suspendisse volutpat feugiat blandit. Pellentesque dignissim, lectus vitae dapibus auctor, ex justo sollicitudin odio, id dignissim m.',
            switch: false,
          },
        ]
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/faq.vue